import { createStore } from "vuex";

const storeConfig = createStore({
  state: {
    config: { name: "amir" },
    isUserInfoLoading: false,
    isSidebarMenuLoading: false,
    registrationCoursesLoading: false,
    menuItems: [],
    userInfo: null,
    messengersInfo: [],
    visibleSidebarMobile: false,
    isMinimizeSidebarDesktop: false,
    mobileHeaderTitleCount: null,
    currentDate: null,
    shouldRefreshCaptcha: false,
    isCaptchaFetching: false,
    showParvandehNotification: false,
    parvandehStatusDetail: null,
    shouldRefreshParvandehStatus: false,
    activeParvandeh: null,
    showProfileRequiredTabs: false,
    isNewUpdateVersion: false,
    isSmsActive: true,
    isAuthMobileLoginActive: true,
    isHeader: true,
    isSidebarMenu: true,
    questionnaireCurrentItem: null,
    mainClass: "lg:p-6 p-4 px-2 lg:px-6 lg:mt-0 mt-14",
    myAnnouncementsBoxVisible: false,
    myAnnouncementsUnreadCount: 0,
    myAnnouncementsAnnouncementTypeId: null,
    isVisibleAnnouncementsBox: false,
    checkScrolledToValidationTouched: true,
  },
  getters: {},
  mutations: {
    mutate(state: any, data: { key: string; value: any }) {
      state[data.key] = data.value;
      if (data.key === "questionnaireCurrentItem") {
        // console.log("questionnaireCurrentItem ==============>", data.value);
      }
    },
  },
  actions: {
    setAction(store: any, data: { key: string; value: any }) {
      store.commit("mutate", data);
    },
  },
  modules: {},
});

export default storeConfig;
